import React from 'react';
import { Container, Content, Header } from './styles';
import { CloseIcon } from '../icons';

type ModalProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
    title: string;
    hiddenBackButton?: boolean;
    children?: React.ReactNode;
    handleClose: () => void;
}

const Modal: React.FC<ModalProps> = ({ id, title, hiddenBackButton = false, children, handleClose }) => {
    return (
        <Container>
            <Content>
                <Header>
                    {title}
                    {!hiddenBackButton && (
                        <CloseIcon id={`${id}.closebutton`} onClick={handleClose} />
                    )}
                </Header>
                <div>
                    {children}
                </div>
            </Content>
        </Container>
    );
};

export { Modal };
export type { ModalProps };
